import type { IconDefinition } from '../index.tsx';

export const iconExchangeAlt: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconExchangeAlt',
  icon: [
    16,
    16,
    [],
    '',
    'M1.02194 5.49978C0.460263 5.49978 0.0234032 5.06292 0.0234032 4.50124C0.0234032 3.97077 0.460263 3.5027 1.02194 3.5027H12.5675L10.7889 1.72406C10.3832 1.34961 10.3832 0.694318 10.7889 0.319867C11.1633 -0.0857889 11.8186 -0.0857889 12.1931 0.319867L15.688 3.81475C16.0936 4.1892 16.0936 4.84449 15.688 5.21894L12.1931 8.71382C12.0059 8.90105 11.7562 8.99466 11.5066 8.99466C11.2257 8.99466 10.9761 8.90105 10.7889 8.71382C10.3832 8.33937 10.3832 7.68408 10.7889 7.30963L12.5675 5.49978H1.02194ZM15.0015 10.4925C15.5319 10.4925 16 10.9605 16 11.491C16 12.0527 15.5319 12.4895 15.0015 12.4895H3.42467L5.20332 14.2994C5.60897 14.6738 5.60897 15.3291 5.20332 15.7036C5.01609 15.8908 4.76646 15.9844 4.51682 15.9844C4.23598 15.9844 3.98635 15.8908 3.79912 15.7036L0.304242 12.2087C-0.101414 11.8343 -0.101414 11.179 0.304242 10.8045L3.79912 7.30963C4.17357 6.90397 4.82886 6.90397 5.20332 7.30963C5.60897 7.68408 5.60897 8.33937 5.20332 8.71382L3.42467 10.4925H15.0015Z',
  ],
};
